import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { CellComponent, CellContext, FilterColumn } from '@grid/models';
import { DataFilterService } from '@grid/services';
import { UntilDestroy } from '@ngneat/until-destroy';

/* eslint-disable @typescript-eslint/no-empty-function */
@UntilDestroy()
@Directive({
  selector: '[filterCellDef]',
})
export class FilterCellDefDirective implements OnChanges {
  @Input('filterCellDef') context: {
    column: FilterColumn;
    cell: { element: HTMLElement };
    placeholder: string;
  };

  private data: { value?: any } = {};

  constructor(
    private container: ViewContainerRef,
    private dataFilterService: DataFilterService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.context) {
      this.initComponent();
    }
  }

  onEdited(): void {
    this.dataFilterService.filterValueChanged$.next([
      this.context.column.columnDef,
      this.data.value,
    ]);
  }

  // #region Private methods

  private initComponent(): void {
    this.container.clear();

    const cellContext: CellContext<any> = {
      column: {
        columnDef: 'value',
        placeholder: this.context.placeholder ?? 'All',
      },
      data: this.data,
      cell: {
        element: this.context.cell.element,
        actions: {
          focus: () => {},
          endEdit: () => {},
          startEdit: () => {},
          setDelegateEditState: () => {},
          onEdited: this.onEdited.bind(this),
        },
        allowEditing: true,
      },
      config: this.context.column.edit.config,
    };

    const editType = this.context.column.edit.type as Type<unknown>;
    const componentInstance = this.container.createComponent(editType)
      .instance as CellComponent<any>;
    componentInstance.context = cellContext;
  }
  // #endregion
}
